import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectContractInitialization = createSelector(
  [(state: AppState) => state.externalProvider.subcontractingContractEnable],
  state => state,
);
